import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CurvedProgressBar',
  props: {
    percentage: null,
    decimals: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { percentage: number, decimals: number };



const percentage = computed(() => Math.min(Math.max(0, props.percentage), 1));

const presentedPercentage = ref(0);

const BAR_SPEED = 38;

const presentedPercentageStr = computed(() => {
  if (isNaN(presentedPercentage.value)) return 0;
  return (presentedPercentage.value * 100).toFixed(props.decimals);
});

function calcProgress() {
  const pointer = document.getElementById('progress-circle');
  if (pointer) {
    if (percentage.value < 0.01) {
      pointer.style.transform = `rotate(${0.75 * 100}deg)`;
    } else {
      pointer.style.transform = `rotate(${(0.75 + percentage.value * 2.1) * 100}deg)`;
    }
  }
}

function incrementProgressLenght(el: Element, value: number, max: number, increment: number) {
  if (percentage.value < 0.01) {
    el.setAttribute('stroke-dasharray', `0% 100%`);
  } else {
    el.setAttribute('stroke-dasharray', `${value * 0.8 * 100}% 100%`);
    if (value + increment < max) {
      setTimeout(() => incrementProgressLenght(el, value + increment, max, increment), 10);
    }
  }
}

function incrementPercentage(max: number, increment: number) {
  presentedPercentage.value = Math.min(presentedPercentage.value + increment, max);
  if (presentedPercentage.value < max) {
    setTimeout(() => incrementPercentage(max, increment), 10);
  }
}

function setStrokeArray() {
  const bar = document.getElementById('progress');
  if (bar) {
    incrementProgressLenght(bar, 0, props.percentage, props.percentage / BAR_SPEED);
  }
}

function calcValues() {
  calcProgress();
  setStrokeArray();
  incrementPercentage(props.percentage, props.percentage / BAR_SPEED);
}

onMounted(() => setTimeout(calcValues, 200));

watch(() => props.percentage, calcValues);

return { __sfc: true,props, percentage, presentedPercentage, BAR_SPEED, presentedPercentageStr, calcProgress, incrementProgressLenght, incrementPercentage, setStrokeArray, calcValues }
}

})